import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { toast, formatearMonedaValue, alerta } from '../../../services/utilities';
import { validar_topes_numero, venta_sorteos, get_vaucher } from '../../../services/Venta';
import { getHoy } from '../../../services/Loterias';
import Swal  from 'sweetalert2';
import jsPDF from 'jspdf';

function VentaSorteos(){

    const esLoteriaSorteo = (loteria) => {
        return loteria?.sorteos === true || loteria?.sorteos === 1 || loteria?.sorteos === '1';
    };

    const obtenerCantidadCifras = (loteria) => {
        const cantidad = parseInt(loteria?.cantidad_cifras_loteria, 10);
        return Number.isNaN(cantidad) ? 0 : cantidad;
    };

    const [idTransaccion, setIdTransaccion] = useState(0);

    useEffect(() => {
        handleGetLoterias();
        setIdTransaccion(0)
    },[]);

    const [loading, setLoading] = useState(false);
    const [loteriasHoy, setLoteriasHoy] = useState([]);

    const loteriasSorteos = Array.isArray(loteriasHoy)
        ? loteriasHoy.filter((loteria) => esLoteriaSorteo(loteria))
        : [];

    const maxCantidadCifrasSorteos = loteriasSorteos.reduce((maximo, loteria) => {
        const cantidad = obtenerCantidadCifras(loteria);
        return cantidad > maximo ? cantidad : maximo;
    }, 0);

    const loteriasSorteosAgrupadas = Object.values(
        loteriasSorteos.reduce((acumulado, loteria) => {
            const actual = acumulado[loteria.id_loteria];

            if(!actual){
                acumulado[loteria.id_loteria] = loteria;
                return acumulado;
            }

            const actualCifras = obtenerCantidadCifras(actual);
            const nuevaCifras = obtenerCantidadCifras(loteria);
            const actualAbierta = actual.disponibilidad === 'abierta';
            const nuevaAbierta = loteria.disponibilidad === 'abierta';

            if((!actualAbierta && nuevaAbierta) || nuevaCifras > actualCifras){
                acumulado[loteria.id_loteria] = loteria;
            }

            return acumulado;
        }, {})
    );
    
    const handelGenerateUUID = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (Math.random() * 16) | 0,
              v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    const [form, setForm] = useState({
        "nombre": "",
        "celular": "",
        "numeros":[],
        "loterias":[],
        "total": 0,
        "version": "WEB"}
    );

    const [numero, setNumero] = useState({
        "id": null,
        "numero": "",
        "valor": "",
        "valor_combinado":"",
        "modalidad_juego_id":"",
        "prefijo":"",
        "loterias":[]
    });

    const handleValidarCantidadCifrasLoteria = (idLoteria) => {
        const loteria = loteriasSorteosAgrupadas.find((item) => String(item.id_loteria) === String(idLoteria));

        if(!loteria){
            return false;
        }

        return numero.numero.length <= obtenerCantidadCifras(loteria);
    };

    const handleInputChangeForm  = (event) => {

        const { name, value } = event.target;

        if(name === 'celular'){
            var inputValue = value.replace(/\D/g, '')
            setForm({ ...form, [name]: inputValue });;
        }else{
            setForm({ ...form, [name]: value });
        }
    };

    const handleInputChange = (event) => {

        const { name, value } = event.target;
        if(name === 'valor' || name === 'valor_combinado'){
            const inputValue = value.replace(/[^\d.,]/g, '');
            setNumero({ ...numero, [name]: inputValue });
        }else if(name === 'numero'){
            const inputValue = value.replace(/\D/g, '');
            setNumero({ ...numero, [name]: inputValue });
        }else{
            setNumero({ ...numero, [name]: value });
        }
    };

    const calcularTotalNumeros = (numeros = []) => {
        return numeros.reduce((total, item) => {
            const valor = parseFloat(item.valor) || 0;
            return total + valor;
        }, 0);
    };

    const handleAgregarNumero = async () => {

        setLoading(true);
        
        try {
        
            await validar_topes_numero(numero.numero, numero.loterias.join(','), numero.valor, numero.valor_combinado, 8).then(response => {
                
                if(response.status !== undefined && response.status === 200){
                    if(response.data.bloqueos_cifras.length === 0 && response.data.bloqueos_numero.length === 0 && response.data.bloqueos_combinado.length === 0){
                        
                        if(numero.valor > 0){

                            setForm(prevForm => {

                                const numerosNormalizados = numero.loterias.map((loteriaId) => {
                                    const loteriaSeleccionada = loteriasSorteosAgrupadas.find((item) => String(item.id_loteria) === String(loteriaId));

                                    return {
                                    id:handelGenerateUUID(),
                                    numero: numero.numero,
                                    valor: numero.valor,
                                    modalidad_juego_id: numero.modalidad_juego_id,
                                    modalidad: 'SORT',
                                    prefijo: loteriaSeleccionada?.prefijo ?? '',
                                    loteria_id: parseInt(loteriaId)
                                    };
                                });
                        
                                const nuevasLoterias = numero.loterias.map(id => parseInt(id));
                                const loteriasUnicas = Array.from(new Set([...prevForm.loterias, ...nuevasLoterias]));
                                const numerosActualizados = [...prevForm.numeros, ...numerosNormalizados];
                        
                                return {
                                    ...prevForm,
                                    numeros: numerosActualizados,
                                    loterias: loteriasUnicas,
                                    total: calcularTotalNumeros(numerosActualizados)
                                };
                            });
                        }

                        if(numero.valor_combinado > 0){

                            setForm(prevForm => {

                                const nuevosNumeros = numero.loterias.map(loteriaId => ({
                                    constLoteria: loteriasSorteosAgrupadas.find((item) => String(item.id_loteria) === String(loteriaId))
                                }));

                                const numerosNormalizados = nuevosNumeros.map(({ constLoteria }) => ({
                                    id:handelGenerateUUID(),
                                    numero: numero.numero,
                                    valor: numero.valor_combinado,
                                    modalidad_juego_id: numero.modalidad_juego_id,
                                    modalidad: 'SORT.C',
                                    prefijo: constLoteria?.prefijo ?? '',
                                    loteria_id: parseInt(constLoteria?.id_loteria ?? 0)
                                }));
                        
                                const nuevasLoterias = numero.loterias.map(id => parseInt(id));
                                const loteriasUnicas = Array.from(new Set([...prevForm.loterias, ...nuevasLoterias]));
                                const numerosActualizados = [...prevForm.numeros, ...numerosNormalizados];
                        
                                return {
                                    ...prevForm,
                                    numeros: numerosActualizados,
                                    loterias: loteriasUnicas,
                                    total: calcularTotalNumeros(numerosActualizados)
                                };
                            });
                        }
                
                        setNumero({
                            "id": null,
                            "numero": "",
                            "valor": "",
                            "valor_combinado": "",
                            "modalidad_juego_id":"",
                            "prefijo":"",
                            "loterias":[]
                        });
                    
                    }else{

                        let texto = '';
                        let arrayBloCifras = Array.isArray(response.data.bloqueos_cifras) ? response.data.bloqueos_cifras : [] ;
                        let arrayBloNumeros = Array.isArray(response.data.bloqueos_numero) ? response.data.bloqueos_numero : [];
                        let arrayBloCombinado = Array.isArray(response.data.bloqueos_combinado) ? response.data.bloqueos_combinado : [];

                        const combinedArray = arrayBloCifras.concat(arrayBloNumeros).concat(arrayBloCombinado);
                        const minValue = combinedArray.reduce((min, current) => {
                            return current.valor_disponible < min ? current.valor_disponible : min;
                        }, Infinity);

                        const uniqueLoterias = [...new Set(combinedArray.map((item) => item.loteria))];
                        const loteriasString = uniqueLoterias.join(', ');

                        let valor_disponible = 0;

                        if(arrayBloCifras.length > 0){
                            texto = 'El valor supera el tope de venta para la cantidad de cifras';
                            valor_disponible = (minValue);

                            setNumero({
                                ...numero,
                                valor: valor_disponible.toString(),
                            });
                            
                        }
                        if(arrayBloNumeros.length > 0){
                            texto = 'El valor supera el tope de venta para el numero';
                            valor_disponible = (minValue);
                            
                            setNumero({
                                ...numero,
                                valor: valor_disponible.toString(),
                            });                            
                        }
                        if(arrayBloCombinado.length > 0){
                            texto = 'El valor supera el tope de venta para el juego combinado';
                            valor_disponible = (minValue);

                            setNumero({
                                ...numero,
                                valor_combinado: valor_disponible.toString(),
                            });
                        }
                        alerta(texto, 'Valor sugerido de venta $' +formatearMonedaValue(valor_disponible)+' | Loterias afectadas:\n'+loteriasString);
                    }
                }else{
                    alerta('No se pudo validar el numero', 'Por favor intente nuevamente, si el problema persiste contacte a soporte.');
                }
            });
        }catch (error) {
            alerta('Error no controlado al validar el numero', 'Por favor intente nuevamente, si el problema persiste contacte a soporte.');
        }
        
        setLoading(false); 
    }

    const handleEliminarNumero = (id, valor) => {
        let numerosTemp = form.numeros.filter((objeto) => objeto.id !== id);
        setForm({ ...form, numeros: numerosTemp, total: calcularTotalNumeros(numerosTemp) });
    };

    const handleConfirmarVenta = () => {
    
        Swal.fire({
            title: "¿Esta seguro de crear esta venta?",
            text: 'Si está seguro, presione el botón "Crear" de lo contrario, "Cancelar"',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: 'grey',
            confirmButtonText: 'Si, Crear',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                handleRealizarVenta();
            }
        });
    }

    const handleRealizarVenta = async () => {
    
        setLoading(true);

        const payload = {
            nombre_cliente: form.nombre,
            celular_cliente: form.celular,
            version: form.version,
            items: form.numeros.map((item) => ({
                numero: item.numero,
                combinado: item.modalidad === 'SORT.C',
                valor: item.valor,
                id_loteria: item.loteria_id
            }))
        };

        try {
            await venta_sorteos(payload).then( response => {
                            
                if(response.status === 201){
                    setIdTransaccion(response.data.id_transaccion)
                    toast('¡ Perfecto !','Venta realizada '+response.data.id_transaccion ,'success');                    
                }else{
                    alerta('Se presento un error al intentar crear la venta',response.data.status_message??response.message);
                }
            });
        }catch (error) {
            alerta('Se presento un error al intentar crear la venta','Error no controlado');
        }

        setLoading(false);
    }

    const imprimirPdf = async () => {
    
        try {

            const response = await get_vaucher(idTransaccion);

            if (response.status === 200 && response.data.status_message === 'OK') {

                let data = response.data.data;
                let y = 10;
                let lineHeight = 4;
                let dynamicHeight = 40 + (data.items.length * lineHeight) + 18;

                const doc = new jsPDF({
                    unit: "mm",
                    format: [55, dynamicHeight],
                });

                doc.setFontSize(8);
                doc.text("==============================", 3, y);
                y += 3;
                doc.text(`RECIBO DE VENTA ${data.id_transaccion}`, 28, y, { align: "center" });
                y += 3;
                doc.text("==============================", 3, y);
                y += 4;
                doc.text(`Fecha: ${data.fecha}`, 3, y);
                y += 4;
                doc.text(`Hora: ${data.hora}`, 3, y);
                y += 4;
                doc.text(`Modalidad: ${data.modalidad}`, 3, y);
                y += 4;
                doc.text("----------------------------------------------------", 3, y);
                y += 4;
                doc.text("NUM", 3, y);
                doc.text("TIPO", 12, y);
                doc.text("LOTERIA", 22, y);
                doc.text("VALOR", 42, y);

                data.items.forEach((item) => {                        
                    y += 4;
                    let loteria = item.loteria.toString();

                    if (loteria.length > 13) {
                        loteria = loteria.substring(0, 13) + "...";
                    }

                    doc.text(`${item.numero}`, 3, y);
                    doc.text(`${item.prefijo}`, 12, y);
                    doc.text(`${loteria}`, 22, y);
                    doc.text(`${item.valor}`, 42, y);
                });

                y += 4;
                doc.text("----------------------------------------------------", 3, y);
                y += 4;
                doc.text(`TOTAL: ${data.total}`, 31, y);
                y += 4;
                doc.text("==============================", 3, y);
                y += 3;
                doc.text("¡Gracias por su compra!", 14, y);
                y += 3;
                doc.text("==============================", 3, y);

                const pdfBlob = doc.output("blob");
                const pdfUrl = URL.createObjectURL(pdfBlob);
                window.open(pdfUrl);

                
            } else {
                alerta('Error al imprimir','No fue posible generar la información de impresión.');
            }
        } catch (error) {
            alerta('Error al compartir:', error);
        }
    };
    

    const handleGetLoterias = async () => {
        setLoading(true);
        try {
            await getHoy().then(response => {
                if(response.status !== undefined && response.status === 200){
                     setLoteriasHoy(response.data.data??[]);
                 }else{
                     alerta('No hay loterias disponibles para el dia de hoy')
                 }
             });
     
        }catch (error) {
            alerta('Error no controlado al cargar las loterias')
            setLoading(false); 
        }

        setTimeout(function() {
            setLoading(false);
        },500);
    }

    const handleCheckiarLoteria = (event, modalidad_juego_id, prefijo) => {

        let updatedLoterias = [...numero.loterias];

        if (event.target.checked && !handleValidarCantidadCifrasLoteria(event.target.value)) {
            alerta(
                'La loteria no soporta la cantidad de cifras',
                'El numero ingresado tiene ' + numero.numero.length + ' cifras y la loteria ' + prefijo + ' solo permite ' + obtenerCantidadCifras(loteriasSorteosAgrupadas.find((item) => String(item.id_loteria) === String(event.target.value))) + '.'
            );
            return;
        }
    
        if (event.target.checked) {
            updatedLoterias.push(event.target.value);
        } else {
            updatedLoterias = updatedLoterias.filter(item => item !== event.target.value);
        }
        setNumero({ ...numero, loterias: updatedLoterias,  modalidad_juego_id : modalidad_juego_id, prefijo });
    }

    const HandleFinalizarVenta = () =>{
        window.location.href = '/venta';
    }

    const renderBalotas = (valorNumero, tabla = false) => {
        const clase = tabla ? 'balota-item-tabla' : 'balota-item';
        return valorNumero.split('').map((digit, index) => (
            <div className={clase} key={`${digit}-${index}`}>{digit}</div>
        ));
    };

    const handleNombreModalidad = (modalidad) => {
        if(modalidad === 'SORT.C'){
            return 'Combinado';
        }

        return 'Pleno';
    };

    const loteriaNoSoportaCantidad = (loteria) => {
        if(numero.numero.length === 0){
            return false;
        }

        return numero.numero.length > obtenerCantidadCifras(loteria);
    };

    return(
        <React.Fragment>
            <div className="modal fade" id="ModalVentaSorteos" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="ModalVentaSorteos" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header modal-header-morado">                            
                            <h1 className="modal-title fs-5" id="staticBackdropLabel">Venta Sorteos</h1>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-md-3'>
                                    <div className="m-0">
                                        <label htmlFor="Numero" className="form-label mt-0">Número</label>
                                        <input 
                                            type="text"
                                            autoComplete="off" 
                                            placeholder='Numero' 
                                            className="form-control input-add-numero" 
                                            id="numero" 
                                            name="numero" 
                                            value={numero.numero}
                                            maxLength={maxCantidadCifrasSorteos || 4} 
                                            onChange={handleInputChange}  
                                        />
                                    </div>                                            
                                </div>
                                <div className='col-md-2'>
                                    <div className="m-0">
                                        <label htmlFor="Numero" className="form-label mt-0">Valor</label>
                                        <input 
                                            type="text" 
                                            autoComplete="off" 
                                            placeholder='$0.0' 
                                            className="form-control input-add-numero" 
                                            id="valor" 
                                            name="valor" 
                                            value={numero.valor} 
                                            onChange={handleInputChange} 
                                        />
                                    </div>
                                </div>
                                <div className='col-md-2'>
                                    <div className="m-0">
                                        <label htmlFor="Numero" className="form-label mt-0">Combiando</label>
                                        <input 
                                            type="text" 
                                            autoComplete="off" 
                                            placeholder='$0.0' 
                                            className="form-control input-add-numero" 
                                            id="valor_combinado" 
                                            name="valor_combinado" 
                                            value={numero.valor_combinado} 
                                            onChange={handleInputChange} 
                                        />
                                    </div>
                                </div>
                                <div className='col-md-5'>   
                                    <div className='content-btn-loterias-pronostico'>                         
                                        <button 
                                            type="button" 
                                            className="btn btn-dark btn-lg"
                                            data-bs-target="#ModalLoteriasSorteos"
                                            data-bs-toggle="modal"                                              
                                            disabled={(numero.numero.length === 0 || (numero.valor <= 0 && numero.valor_combinado <= 0)) && loading === false}
                                        >Seleccionar loterias
                                        </button>
                                    </div>                                       
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-7'>
                                    <div className='card-table-add-numeros mt-3'>
                                        { form.numeros.length > 0 ?
                                        <div className='table-container'>
                                            <div className="table-responsive-sm">
                                                <table className='table table-hover table-sm'>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-center'>Número</th>
                                                            <th className='text-secondary text-center'>Modalidad</th>
                                                            <th className='text-secondary text-center'>Valor</th>
                                                            <th className='text-secondary'>Loteria</th>
                                                            <th className='text-secondary'></th>
                                                        </tr>
                                                    </thead>                                                
                                                    <tbody>
                                                    {Array.isArray(form.numeros) ? form.numeros.map((numeroItem, index) => (
                                                        <tr key={index} className='align-middle'>
                                                            <th className='text-center'>
                                                                <div className='div-content-balotas-tabla'>
                                                                    {renderBalotas(numeroItem.numero, true)}
                                                                </div>
                                                            </th>
                                                            <th className={numeroItem.modalidad === 'SORT.C' ? 'text-start text-primary' : 'text-start text-dark'}>
                                                                {handleNombreModalidad(numeroItem.modalidad)}
                                                            </th>
                                                            <th className='text-center text-success'>${formatearMonedaValue(numeroItem.valor)}</th>
                                                            <th style={{fontSize:'12px'}}>{numeroItem.prefijo}</th>
                                                            <th>
                                                                {idTransaccion === 0?
                                                                <i 
                                                                    className="bi bi-trash text-danger" 
                                                                    style={{cursor:'pointer'}}
                                                                    onClick={() => handleEliminarNumero(numeroItem.id, numeroItem.valor)}
                                                                >                                                                            
                                                                </i>
                                                                :''}
                                                            </th>
                                                        </tr>
                                                        )) : <tr></tr>}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        :
                                        <div className='text-center text-secondary my-4 d-flex  justify-content-center align-items-center flex-column' style={{ 'height' : '100px'}}>
                                            <h4>Aún no se han agregado números.</h4>
                                            <p>Por favor, añade al menos un número para continuar con el sorteo.</p>
                                        </div>
                                        }
                                    </div>
                                </div>
                                <div className='col-md-5'>
                                    <div className='card-table-add-numeros mt-3'>
                                        <h5 className='m-0 text-success'>Datos del cliente</h5>
                                        <hr className='mt-0'></hr>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className="form-floating">
                                                    <input 
                                                        type="text"
                                                        className="form-control " 
                                                        id="nombre" 
                                                        name="nombre" 
                                                        value={form.nombre} 
                                                        onChange={handleInputChangeForm} 
                                                    />
                                                    <label htmlFor="nombre" className="form-label mt-0">Nombre</label>
                                                </div>
                                            </div>
                                            <div className='col-md-12 mt-3'>
                                                <div className="form-floating">
                                                    <input 
                                                        type="text"
                                                        className="form-control " 
                                                        id="celular" 
                                                        name="celular" 
                                                        value={form.celular} 
                                                        maxLength={10}
                                                        onChange={handleInputChangeForm} 
                                                    />
                                                    <label htmlFor="nombre" className="form-label mt-0">Celular</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                        <div className='div-total-venta'>
                            <div className='div-texto-total'>  
                                {idTransaccion > 0 ?                               
                                    <h4  className="text-success">
                                        <i className="bi bi-check-circle text-success" style={{fontSize:'22px'}}></i> Transcción exitosa {idTransaccion}
                                    </h4>:                                        
                                    <h4 className='m-0'>Total venta: <span className='text-success'><b>${formatearMonedaValue(form.total)}</b></span></h4>
                                }                             
                            </div>
                            <div className='div-btns'>                                 
                                {idTransaccion > 0 ?
                                    <>
                                        <button 
                                            type="button" 
                                            className="btn btn-dark"
                                            disabled={idTransaccion <= 0}
                                            onClick={imprimirPdf}
                                        >
                                            <i className="bi bi-printer"></i> Imprimir
                                        </button>
                                        <button 
                                            type="button" 
                                            className="btn btn-success mx-2"
                                            disabled={form.numeros.length <= 0 || form.total === 0}
                                            onClick={HandleFinalizarVenta}
                                        >Finalizar
                                        </button>
                                    </>
                                :   
                                    <>
                                        <button type="button" className="btn btn-secondary mx-2" data-bs-dismiss="modal">Cancelar</button>                                
                                        <button 
                                            type="button" 
                                            className="btn btn-danger mx-2"
                                            disabled={form.numeros.length <= 0}
                                            onClick={handleConfirmarVenta}
                                        >Realizar venta
                                        </button>
                                    </>
                                }                                   
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
            </div>

            <div className="modal fade" id="ModalLoteriasSorteos" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true" aria-labelledby="ModalLoteriasSorteos" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header modal-header-morado">
                            <h1 className="modal-title fs-5" id="staticBackdropLabel">Seleccione una o mas loterias</h1>                 
                        </div>
                        <div className="modal-body">
                            <p className='title-valor-pronostico'>Valor sorteo<span className='valor-pronostico'>${formatearMonedaValue((parseFloat(numero.valor || 0) + parseFloat(numero.valor_combinado || 0)) * numero.loterias.length)}</span></p>
                            <div className='div-content-balotas'>
                                {renderBalotas(numero.numero, false)}
                            </div>
                            <hr></hr>
                            <div className='table-container'>
                                <div className="table-responsive-sm">
                                    <table className="table table-hover table-borderless table-sm">
                                        <tbody>
                                            {Array.isArray(loteriasSorteosAgrupadas) ? loteriasSorteosAgrupadas.map((loteria) => (
                                                <tr className='fila-loteria-pronostico' key={loteria.id_loteria}>                                                    
                                                    <td style={{width:'185px'}}>{loteria.prefijo}</td>
                                                    <td>
                                                        {loteria.disponibilidad === 'cerrada' ?
                                                            <span className="badge text-bg-danger mx-2">Cerrada</span>
                                                        : loteriaNoSoportaCantidad(loteria) ?
                                                            <span className="badge text-bg-warning mx-2">Max. {obtenerCantidadCifras(loteria)} cifras</span>
                                                        :
                                                            <div className="form-check text-center form-switch">
                                                                <input 
                                                                    disabled={loteria.disponibilidad === 'cerrada' || loteriaNoSoportaCantidad(loteria)}
                                                                    className="form-check-input is-invalid" 
                                                                    type="checkbox" 
                                                                    role="switch"
                                                                    checked={numero.loterias.includes(String(loteria.id_loteria))}
                                                                    value={loteria.id_loteria} 
                                                                    onChange={(e)=>handleCheckiarLoteria(e, loteria.id_modalidad_juego, loteria.prefijo)} 
                                                                    id={`sorteo_${loteria.id_loteria}`} 
                                                                />
                                                            </div>
                                                        }
                                                    </td>
                                                </tr> 
                                            )) : <tr></tr>}                                           
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary mx-2" data-bs-target="#ModalVentaSorteos" data-bs-toggle="modal">Cancelar</button>
                            <button 
                                className="btn btn-danger" 
                                data-bs-target="#ModalVentaSorteos" 
                                data-bs-toggle="modal"
                                disabled={numero.loterias.length === 0}                                
                                onClick={handleAgregarNumero}
                            >
                                <i className="bi bi-plus-circle"></i> Agregar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default  connect(null, null)(VentaSorteos);
